// extracted by mini-css-extract-plugin
module.exports = {"atrribute":"PunkDetail_atrribute__FzLVo","attributesContainer":"PunkDetail_attributesContainer__3lPFl","attributesGroup":"PunkDetail_attributesGroup__X_PEd"};